<template>
    <div>
        <Card>
            <template #content>
                <div class="space-y-2">
                    <div class="flex items-center gap-1">
                        <SchedulingStateBadge
                            :entityWithSchedulingState="attendanceData"
                        />
                        <PaymentStateBadge
                            v-if="reservationData.bookingPayment"
                            :entityWithPaymentState="reservationData"
                        />
                        <IsRecurringMeetingBadge
                            v-if="meetingData.meeting.isRecurring"
                        />
                    </div>
                    <div class="text-lg font-medium">
                        Meeting #{{ meetingData.meeting.uniqueCode }}
                    </div>
                </div>
                <div class="space-y-2 mt-2">
                    <MeetingCardItem iconName="check">
                        <span>{{ meetingData.service.title }}</span>
                    </MeetingCardItem>
                    <template v-if="reservationData.bookingPayment">
                        <MeetingCardItem iconName="dollar-sign">
                            <span>
                                {{
                                    reservationData.bookingPayment.amount.getValueAsDecimal()
                                }}
                                {{
                                    reservationData.bookingPayment.amount
                                        .currency
                                }}
                            </span>
                        </MeetingCardItem>
                    </template>
                    <MeetingCardItem iconName="user">
                        <span>{{ meetingData.user.getFullName() }}</span>
                    </MeetingCardItem>
                    <MeetingCardItem iconName="calendar">
                        <span>
                            {{ reservationData.reservation.dateFormatted }}
                            {{ reservationData.reservation.startAtFormatted }}
                            ({{ reservationData.reservation.selectedTimeZone }})
                        </span>
                    </MeetingCardItem>
                    <MeetingCardItem iconName="clock">
                        <span>{{ meetingData.meeting.duration }} mins</span>
                    </MeetingCardItem>
                    <MeetingCardItem iconName="user">
                        <span>
                            {{ reservationData.customer.getFullName() }}
                            ({{ reservationData.customer.email }})
                        </span>
                    </MeetingCardItem>
                    <MeetingCardItem iconName="users">
                        <span>
                            {{
                                reservationData.reservation.getNumberOfReservedSeatsLabel()
                            }}
                        </span>
                    </MeetingCardItem>
                    <MeetingCardItem iconName="comment">
                        <span v-if="reservationData.reservation.notes?.length">
                            {{ reservationData.reservation.notes }}
                        </span>
                        <span
                            v-else
                            class="text-gray-400"
                        >
                            (empty)
                        </span>
                    </MeetingCardItem>
                    <!-- TODO: Render location info -->
                </div>
                <div
                    class="flex flex-col lg:flex-row w-full gap-2 justify-end mt-8"
                >
                    <slot name="actions" />
                </div>
            </template>
        </Card>
    </div>
</template>

<script setup lang="ts">
    import { type PropType } from 'vue'
    import Card from '@/Shared/Component/Card.vue'
    import MeetingData from '@/App/Booking/Meeting/Entity/MeetingData'
    import MeetingCardItem from '@/BookingForm/BookingForm/Component/MeetingCardItem.vue'
    import SchedulingStateBadge from '@/App/Booking/Meeting/Component/SchedulingStateBadge.vue'
    import PaymentStateBadge from '@/App/Booking/Meeting/Component/PaymentStateBadge.vue'
    import IsRecurringMeetingBadge from '@/App/Booking/Meeting/Component/IsRecurringMeetingBadge.vue'
    import AttendanceData from '@/App/Booking/Attendance/Entity/AttendanceData'
    import ReservationData from '@/App/Booking/Reservation/Entity/ReservationData'

    const emits = defineEmits<{
        onError: [{ errorMessage: string | null }]
        onMeetingUpdated: [{ meetingData: MeetingData }]
    }>()

    const props = defineProps({
        meetingData: {
            type: Object as PropType<MeetingData>,
            required: true,
        },
        attendanceData: {
            type: Object as PropType<AttendanceData>,
            required: true,
        },
        reservationData: {
            type: Object as PropType<ReservationData>,
            required: true,
        },
    })
</script>
